import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import WhatIsOnboarding from './components/WhatIsOnboarding';
import WhyEmployeesLeave from './components/WhyEmployeesLeave';
import WhyBusinessNeedsOnboarding from './components/WhyBusinessNeedsOnboarding';
import ChecklistProblems from './components/ChecklistProblems';
import MainMistakes from './components/MainMistakes';
import OnboardingStages from './components/OnboardingStages';
import ProgramComponents from './components/ProgramComponents';
import ManagerRole from './components/ManagerRole';
import MentorRole from './components/MentorRole';
import MeasureEffectiveness from './components/MeasureEffectiveness';
import CompanyResults from './components/CompanyResults';
import CaseStudy from './components/CaseStudy';
import Formats from './components/Formats';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const onboardingNavLinks = [
  { label: 'Что это', target: 'what-is' },
  { label: 'Ошибки', target: 'mistakes' },
  { label: 'Этапы', target: 'stages' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function OnboardingPage() {


  return (
    <>
      
      <SeoTitle title="Адаптация новых сотрудников | Business Training" />
      <PageJsonLd />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={onboardingNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhatIsOnboarding />
        <WhyEmployeesLeave />
        <WhyBusinessNeedsOnboarding />
        <ChecklistProblems />
        <div id="mistakes">
          <MainMistakes />
        </div>
        <div id="stages">
          <OnboardingStages />
        </div>
        <ProgramComponents />
        <ManagerRole />
        <MentorRole />
        <MeasureEffectiveness />
        <div id="results">
          <CompanyResults />
        </div>
        <CaseStudy />
        <Formats />
        <WhyWorkWithMe />
        <LeadMagnetBlock variant="full" />
        <CTASection />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}